import { z } from "zod";

//const plans = ["free", "basic", "medium", "pro"];

/*export const mappedPlans = Object.fromEntries(
  plans.map(plan => [
    plan,
    plan.charAt(0).toUpperCase() + plan.slice(1)
  ])
);*/

export const userSchema = z.object({
  username: z
    .string()
    .min(3, {
      message: "Name must be at least 3 characters long",
    })
    .max(200, {
      message: "Name must be less than 200 characters long",
    }),
  email: z.string().email({
    message: "Please enter a valid email",
  }),
  password: z.string().min(6, {
    message: "Password must be at least 6 characters long",
  }),
  confirmPassword: z.string().min(6, {
    message: "Password must be at least 6 characters long",
  }),
}).refine(data => data.password === data.confirmPassword, {
    message: "Passwords must match",
    path: ["confirmPassword"]
});


// validations/userSchema.js (TEMPORALMENTE SIMPLIFICADO)
/*import { z } from "zod";

export const userSchema = z.object({
    //username: z.string(),
    username: z.string().min(3, { message: "Usuario debe tener al menos 3 caracteres" }), // Validación MUY SIMPLE para username
});*/